import { render, staticRenderFns } from "./Big5Questionnaire.vue?vue&type=template&id=29d32951&scoped=true"
import script from "./Big5Questionnaire.vue?vue&type=script&lang=js"
export * from "./Big5Questionnaire.vue?vue&type=script&lang=js"
import style0 from "./Big5Questionnaire.vue?vue&type=style&index=0&id=29d32951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d32951",
  null
  
)

export default component.exports